/**
 * 分享邀请
 * @returns
 */
import {
  Box,
  Flex,
  Image,
  Text,
  Button,
  Center,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Input,
  Select,
  useDisclosure,
} from "@chakra-ui/react";
import Bg1 from "@/assets/images/invitebg1.png";
import InviteImg1 from "@/assets/images/inviteimg1.png";
import EchartsComponent, {
  MyChartOptions,
} from "@/components/echartsComponent";
import { useNavigate } from "react-router-dom";
import InviteModal from "@/components/inviteModal";
import sharebanner from "@/assets/images/sharebanner1.png";
import { useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "@/reducer/userslice";

const ShareInvitation = () => {
  const user = useSelector(selectUser);
  const navigate = useNavigate();
  const InviteControl = useDisclosure();
  // const [linkSrc, setLinkSrc] = useState<string>('https://www/aldgptai.com');
  const linkSrc = 'https://www/aldgptai.com?rand_code='+user.rand_code;
  
  // 图表配置项
  const lineOption: MyChartOptions = {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "cross",
      },
      padding: [5, 10],
    },
    // legend: {
    //   data: ['销量'],
    // },
    xAxis: {
      data: ["2023/07", "2023/07", "2023/07", "2023/07", "2023/07", "2023/07"],
      show: true,
      boundaryGap: false,
      axisLabel: {
        interval: 0, // 强制显示所有标签
        showMaxLabel: true,
        margin: 10,
      },
      axisTick: {
        show: false,
      },
    },
    yAxis: {
      axisLabel: {
        // 使用 formatter 函数来格式化标签文本
        formatter: "{value} 人", // 这里的 '{value} 人' 就是标签加上了单位 "人"
        margin: 20, // 设置刻度标签距离轴的距离为20
      },
      axisTick: {
        show: false,
      },
    },
    grid: {
      left: 0,
      right: 30,
      bottom: 0,
      top: 10,
      containLabel: true, // 是否包含坐标轴的标签
    },
    series: [
      {
        name: "注册量",
        type: "line",
        // smooth: true,
        data: [10, 20, 36, 10, 10, 20],
        animationDuration: 2800,
        animationEasing: "cubicInOut",
      },
    ],
  };

  // 列表数据
  const tableData = [
    {
      username: "13521352904",
      createAt: "2024/09/08 ：08:52:19",
      origin: "微信邀请",
      total: "2796积分",
      num: "1024张图",
      lastLogin: "7天前",
    },
  ];

  const handleInvite = () => {
    InviteControl.onOpen();
  }
  const handleToProfile = () => {

  }

  return (
    <Box overflow={"hidden"}>
      <Box width="80%" m="0 auto">
        <Box
          mt="40px"
          mb="20px"
          color="#27314D"
          fontWeight="bold"
          fontSize="24px"
        >
          分享邀请
        </Box>
        <Box
          h="149px"
          background={"linear-gradient(90deg, #8E94A9 0%, #27314D 100%) "}
        >
          <Flex
            w="100%"
            justifyContent="space-around"
            alignItems="center"
            style={{
              height: "100%",
              backgroundImage: `url('${Bg1}')`,
              backgroundPosition: "top right",
              backgroundRepeat: "no-repeat",
            }}
          >
            <Box>
              <Box color={"#E6E6E6"} fontSize="14px" mb="10px">
                共邀请
              </Box>
              <Flex alignItems={"end"}>
                <Box
                  color={"#ffffff"}
                  fontSize="48px"
                  fontWeight={"400"}
                  lineHeight={"48px"}
                  fontFamily="Allerta"
                >
                  201{" "}
                </Box>
                <Box color={"#E6E6E6"} fontSize="14px" ml="5px">
                  人
                </Box>
              </Flex>
            </Box>
            <Box>
              <Box color={"#E6E6E6"} fontSize="14px" mb="10px">
                共获得
              </Box>
              <Flex alignItems={"end"}>
                <Box
                  color={"#ffffff"}
                  fontSize="48px"
                  fontWeight={"400"}
                  lineHeight={"48px"}
                  fontFamily="Allerta"
                >
                  10050
                </Box>
                <Box color={"#E6E6E6"} fontSize="14px" ml="5px">
                  积分
                </Box>
              </Flex>
            </Box>
            <Box cursor={"pointer"} onClick={handleInvite}>
              <Flex
                alignItems={"center"}
                color={"#ffffff"}
                fontSize="36px"
                fontWeight={"bold"}
              >
                <Text>继续邀请</Text>
                <Image ml="10px" src={InviteImg1} />
              </Flex>
            </Box>
          </Flex>
        </Box>

        {/* 折线图 */}
        <Flex justifyContent={"space-between"} alignItems="center" mt="40px"  mb="20px">
          <Box
            color={"#27314D"}
            fontSize="18px"
            fontWeight={"bold"}
          >
            数据趋势
          </Box>

          {/* <Flex fontSize={"12px"} gap="5px" color="#8E94A9" alignItems={"center"}>
            <Text>注册时间: </Text>
            <Input placeholder="请选择" w="150px" fontSize={"12px"} color={"#27314D"} size="xs" type="date" />
            <Text >渠道: </Text>
            <Select color={"#27314D"} fontSize={"12px"} w="80px" size="xs" placeholder="请选择">
              <option value=" 微信">微信</option>
            </Select>
            <Text >消费等级: </Text>
            <Select color={"#27314D"} fontSize={"12px"} w="80px" size="xs" placeholder="请选择">
              <option value="">50-100</option>
            </Select>
            <Text >作品数量: </Text>
            <Select color={"#27314D"} fontSize={"12px"} w="80px" size="xs" placeholder="请选择">
              <option value="">50-100</option>
            </Select>
          </Flex> */}
        </Flex>
        
        <Box>
          
        </Box>
        <Box h="268px">
          <EchartsComponent chartsOption={lineOption} />
        </Box>
        <Box
          color={"#27314D"}
          fontSize="18px"
          fontWeight={"bold"}
          mt="40px"
          mb="28px"
        >
          用户数据
        </Box>
        <Box mb="30px">
          <TableContainer>
            <Table variant="simple" fontSize="14px" fontWeight={"normal"}>
              <Thead color={"#333333"}>
                <Tr>
                  <Th fontSize="14px" fontWeight={"normal"} textAlign="center">
                    用户名
                  </Th>
                  <Th fontSize="14px" fontWeight={"normal"} textAlign="center">
                    注册时间
                  </Th>
                  <Th fontSize="14px" fontWeight={"normal"} textAlign="center">
                    来源渠道
                  </Th>
                  <Th fontSize="14px" fontWeight={"normal"} textAlign="center">
                    总消费
                  </Th>
                  <Th fontSize="14px" fontWeight={"normal"} textAlign="center">
                    作品数量
                  </Th>
                  <Th fontSize="14px" fontWeight={"normal"} textAlign="center">
                    最后登录
                  </Th>
                  <Th fontSize="14px" fontWeight={"normal"} textAlign="center">
                    操作
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {tableData.map((row, index) => (
                  <Tr key={index} color="#333333">
                    <Td textAlign="center">{row.username}</Td>
                    <Td textAlign="center">{row.createAt}</Td>
                    <Td textAlign="center">{row.origin}</Td>
                    <Td textAlign="center">{row.total}</Td>
                    <Td textAlign="center">{row.num}</Td>
                    <Td textAlign="center">{row.lastLogin}</Td>
                    <Td textAlign="center">
                      <Flex justifyContent={"center"} gap="30px">
                        <Box
                          cursor={"pointer"}
                          _hover={{
                            color: "#496AE1",
                          }}
                          onClick={()=>handleToProfile}
                        >
                          主页
                        </Box>
                        {/* <Box
                          cursor={"pointer"}
                          _hover={{
                            color: "#496AE1",
                          }}
                        >
                          联系
                        </Box> */}
                      </Flex>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
      <InviteModal isOpen={InviteControl.isOpen} bannerSrc={`${sharebanner}`} linkSrc={linkSrc} title={"邀请好友"} onClose={InviteControl.onClose}  />
    </Box>
  );
};

export default ShareInvitation;
